import createMathOperation from './_createMathOperation.js';

/**
 * Divide two numbers.
 *
 * @static
 * @memberOf _
 * @since 4.7.0
 * @category Math
 * @param {number} dividend The first number in a division.
 * @param {number} divisor The second number in a division.
 * @returns {number} Returns the quotient.
 * @example
 *
 * _.divide(6, 4);
 * // => 1.5
 */
var divide = createMathOperation(function(dividend, divisor) {
  return dividend / divisor;
}, 1);

export default divide;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/divide.js
// module id = 388
// module chunks = 0